"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@socket/success",
  ERROR: "@@socket/error",
  SOCKET_RESPONSE: "@@socket/socket-response",
  SOCKET_LOADING: "@@socket/socket-loading",
  NOTIFICATION_DELETE: "@@socket/notification-delete",
  MULTI_STATUS_SUCCESS: "@@socket/multi-status-success",
  MULTI_STATUS_ERROR: "@@socket/multi-status-error",
  MUTE_UNMUTE: "@@socket/notification-mute-unmute",
  MINIMIZE: "@@socket/notification-minimize",
  XLSX: "@@socket/xlsx-response",
  READ: "@@socket/notification-read",
  RESET: "@@socket/reset",
  SOCKET_PDF: "@@socket/pdf",
  SOCKET_LOADING_RECORD: "@@socket/loading-record",
  SOCKET_SUCCESS_RECORD: "@@socket/success-record",
  SOCKET_ERROR_RECORD: "@@socket/error-record",
  SOCKET_RESET_RECORD: "@@socket/reset-record",
  SOCKET_RESPONSE_RECORD: "@@socket/socket-response-record",
  READ_FOR_RECORD: "@@socket/notification-read-record",
  MINIMIZE_RECORD: "@@socket/notification-minimize-record"
};
exports.actionTypes = actionTypes;